import './Resubscribed.scss';

const Resubscribed = ({ t, onGoHome }) => {
    return (
        <>
            <h2 className="unsubscribe__resubscribed__title">{t.text1}</h2>
            <p className="unsubscribe__resubscribed__subtitle">{t.text2}</p>
            <p className="unsubscribe__resubscribed__text">{t.text3}</p>
            <button
                onClick={onGoHome}
                className="unsubscribe__button"
            >
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                {t.button}
            </button>
        </>
    );
};

export default Resubscribed;